module.exports = __webpack_public_path__ + "img/rankup_bar.c4162445.svg";